import { type ComponentPropsWithoutRef } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { ClickTracking } from '@/components/ClickTracking';
import { ResetIcon, XIcon } from '@/icons';
import { usePublicCategoryFilter } from '@/module/public/hooks';
import { type FilterType, useFilterSelectedValues } from '@/module/public/hooks/useFilterSelectedValues';
import { useIsSmallerThanTabletSm } from '@/module/public/hooks/useIsSmallerThanTabletSm';
import { useAccordionStorage } from '@/module/public/store/AccordionStore';
import { IconButton } from '@/ui_v3';
import { cn } from '@/utils';
export const FilterHeader = (props: {
  onClose?: () => void;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    isSubSubjectSelected
  } = usePublicCategoryFilter();
  const {
    values,
    remove,
    removeAll
  } = useFilterSelectedValues();
  const {
    collapseSubjectGroup
  } = useAccordionStorage();
  const isTabletSm = useIsSmallerThanTabletSm();
  return <div className={'w-full border-b-[1px] border-b-alternative'} data-sentry-component="FilterHeader" data-sentry-source-file="FilterHeader.tsx">
      <div className={cn('flex items-center justify-center gap-none self-stretch p-md pb-xs')}>
        <span className={'flex-1 text-left text-heading-md-bold text-default'}>
          {t('public.filter')}
        </span>
        <ClickTracking eventName={'filter_reset'} eventProperties={undefined} data-sentry-element="ClickTracking" data-sentry-source-file="FilterHeader.tsx">
          <IconButton onClick={removeAll} size={isTabletSm ? 'sm' : 'xs'} rounded={'full'} variant={'transparent'} intent={'neutral'} data-sentry-element="IconButton" data-sentry-source-file="FilterHeader.tsx">
            <ResetIcon size={isTabletSm ? 'md' : 'xs'} fill={ICON_COLOR.neutral} data-sentry-element="ResetIcon" data-sentry-source-file="FilterHeader.tsx" />
          </IconButton>
        </ClickTracking>

        {props.onClose && <IconButton size={isTabletSm ? 'sm' : 'md'} variant={'transparent'} intent={'neutral'} onClick={props.onClose}>
            <XIcon size={isTabletSm ? 'md' : 'xs'} className={'shrink-0'} fill={ICON_COLOR.neutral} />
          </IconButton>}
      </div>
      {!!values.length && <div className={'flex flex-wrap gap-2xs px-sm py-xs'}>
          {values.map(v => <ChipWithCloseIcon key={v.type + v.value} onClose={() => {
        if (v.type === 'subject' && !isSubSubjectSelected) {
          collapseSubjectGroup(v.value);
        }
        remove(v.value, v.type as FilterType);
      }}>
              {v.name}
            </ChipWithCloseIcon>)}
        </div>}
    </div>;
};
const ChipWithCloseIcon = (props: ComponentPropsWithoutRef<'div'> & {
  onClose: () => void;
}) => {
  return <div className={cn('px-sm py-xs bg-gray-100', 'text-gray-700  text-body-md-semibold', 'flex min-w-[46px] items-center gap-4xs rounded-xl border border-[rgba(28,_27,_31,_0.04)]')} data-sentry-component="ChipWithCloseIcon" data-sentry-source-file="FilterHeader.tsx">
      {props.children}
      <div onClick={props.onClose} className={'m-3xs flex shrink-0 cursor-pointer'}>
        <XIcon className={'shrink-0 '} size={'2xs'} fill={ICON_COLOR.neutral} data-sentry-element="XIcon" data-sentry-source-file="FilterHeader.tsx" />
      </div>
    </div>;
};